class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector(
      '[data-recommendations]'
    );
    if (!recommendations) return;
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const recommendationsHMTL = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]').innerHTML;
        if (!recommendationsHMTL) return;
        this.classList.remove('hidden');
        recommendations.innerHTML = recommendationsHMTL;
        this.initSlider();
      });
  }

  initSlider() {
    const swiperEl = this.querySelector('.swiper');
    const swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: 8
    };
    const prevEl = swiperEl.querySelector('.cart-recommendations__arrow--prev');
    const nextEl = swiperEl.querySelector('.cart-recommendations__arrow--next');
    if (prevEl && nextEl) {
      swiperConfig.navigation = {
        prevEl: prevEl,
        nextEl: nextEl
      };
    }
    this.slider = new Swiper(swiperEl, swiperConfig);
  }
}

customElements.define('cart-recommendations', CartRecommendations);
